// PARAQTA — Landing беті: жаңа дизайн (Step L1+).
// Hero + Top Nav (Step L1) — features/landing/hero.js render жасайды.
// Step L2-L5 қабаттары — кейінгі sub-step-терде қосылады.

import { api } from '../../core/api.js';
import { show } from '../../core/router.js';
import { esc } from '../../utils/format.js';
import { toast } from '../../utils/toast.js';
import { coverBox } from '../../utils/covers.js';
import { loginDone } from '../auth/index.js';
import { enterGuest } from '../auth/login-modal.js';
import { doSearch } from '../search/index.js';
import { openBookPage } from '../book-page/index.js';
import { setCatalogGenre } from '../catalog/index.js';
import { initGoals } from '../goals/index.js';
import { renderHero } from './hero.js';
import { renderFeedPreview } from './feed-preview.js';
import { renderPopularBook } from './popular-book.js';
import { renderLeadersMini } from './leaders-mini.js';
import { renderQuoteFooter } from './quote-footer.js';
import { renderComingSoonLanding } from './coming-soon.js';
import { renderNewLanding } from './new-landing.js';
import { renderShyraqLanding, mountShyraqLanding } from './shyraq-landing.js';

// 30.09.2026: «Шамнан шырақ» басты беті (founder бекітті). Кері қайту — false
// (ескі new-landing.js орнында тұр) немесе бір рет қарау үшін ?landing=old.
const SHYRAQ_LANDING = true;

// Pre-launch flag — 1 маусым 2026 кейін false → original full landing restore.
// Founder admin bypass: https://paraqta.kz/?admin=1
const COMING_SOON_MODE = false;

function isAdminBypass() {
  try {
    return new URLSearchParams(window.location.search).get('admin') === '1';
  } catch { return false; }
}

export async function loadLanding() {
  if (COMING_SOON_MODE && !isAdminBypass()) {
    const d = await api('/api/landing').catch(() => ({ stats: {} }));
    const page = document.getElementById('landingPage');
    if (page) page.innerHTML = renderComingSoonLanding(d.stats || {});
    return;
  }

  // Жаңа landing (миссиямен үндес). COMING_SOON_MODE=false болғанда немесе ?admin=1.
  const d = await api('/api/landing').catch(() => ({ stats: {} }));
  const page = document.getElementById('landingPage');
  const useShyraq = SHYRAQ_LANDING && new URLSearchParams(location.search).get('landing') !== 'old';
  if (page) {
    page.innerHTML = useShyraq ? renderShyraqLanding(d.stats || {}) : renderNewLanding(d.stats || {});
    if (useShyraq) mountShyraqLanding(page);
  }
  renderEventBanner(page);
  // Жаңа landing — әрқашан light; қалқыма тема ауыстырғышын жасырамыз.
  const tf = document.getElementById('themeFloat');
  if (tf) tf.style.display = 'none';
}

// ── Оқиға бөлмесі ашық тұрғанда — басты бетте кіру жолы ──────────────
// Неге керек: пикник бетбелгісіндегі басылған QR жалпы paraqta.kz-ке
// апарады, ал келген адамға бөлмеге ТІКЕЛЕЙ жол керек (әрі Telegram-сыз
// кіру тек /r/КОД бетінде бар). Бөлме кестесі жабық тұрса — блок мүлдем
// шықпайды, сондықтан қалған күндері басты бет өзгермейді.
async function renderEventBanner(page) {
  if (!page) return;
  try {
    const r = await api('/api/rooms');
    const ev = (r.rooms || []).find(x => x && x.is_event);
    if (!ev) return;
    const sub = [ev.city, ev.subtitle].filter(Boolean).join(' · ');
    const a = document.createElement('a');
    a.href = '/r/' + encodeURIComponent(ev.code);
    a.setAttribute('data-pq-event', ev.code);
    // ❗box-sizing + width шектеуі МІНДЕТТІ: онсыз блок экраннан асып,
    // беттің бүкіл оң жағын (тіпті жоғарғы нав-ды) қиып жіберді.
    a.style.cssText = 'box-sizing:border-box;display:flex;align-items:center;gap:12px;'
      + 'width:min(640px,calc(100% - 24px));margin:12px auto 16px;padding:14px 16px;'
      + 'border-radius:16px;text-decoration:none;overflow:hidden;'
      + 'background:linear-gradient(135deg,#1E160D,#2C1F12);border:1px solid rgba(246,206,132,.34);'
      + 'box-shadow:0 10px 30px -14px rgba(0,0,0,.6)';
    a.innerHTML =
      `<span style="font-size:27px;line-height:1;flex:none">${esc(ev.emoji || '📚')}</span>`
      + '<span style="flex:1;min-width:0">'
      + `<span style="display:block;font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:#F6CE84;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${esc(sub || 'Бүгін ашық')}</span>`
      + `<span style="display:block;font-size:16px;font-weight:700;color:#F3EADA;margin-top:2px;line-height:1.25">${esc(ev.name)} ашық</span>`
      + '<span style="display:block;font-size:12px;color:#BFAE93;margin-top:2px;line-height:1.3">Бір басып кір де, бірге оқы</span>'
      + '</span>'
      + '<span style="flex:none;white-space:nowrap;font-size:13px;font-weight:700;color:#241A0C;'
      + 'background:#F6CE84;border-radius:999px;padding:9px 15px">Кіру</span>';
    // «Шамнан шырақ» бетінде — hero ішіндегі арнайы орынға (бекітулі нав астында қалмасын).
    const slot = page.querySelector('[data-event-slot]');
    if (slot) { a.style.margin = '0 auto'; slot.appendChild(a); }
    else page.insertBefore(a, page.firstChild);
  } catch (_) { /* блок болмаса — басты бет әдеттегідей */ }
}

export async function landingLiveSearch(q) {
  const el = document.getElementById('landingSearchResults');
  if (!q || q.length < 2) { el.classList.remove('open'); return; }
  const res = await api('/api/search?q=' + encodeURIComponent(q));
  const items = (res.results || []).slice(0, 6);
  if (!items.length) {
    el.innerHTML = '<div style="padding:14px;font-size:.82rem;color:var(--ink4)">Ештеңе табылмады</div>';
    el.classList.add('open');
    return;
  }
  el.innerHTML = items.map(r => {
    const cover = coverBox(r.title, r.author, r.cover_url);
    const attrs = r.type === 'kitap'
      ? 'data-action="open-book-landing-by-title" data-title="' + esc(r.title) + '"'
      : '';
    return '<div class="land-sr" ' + attrs + '><div class="land-sr-cover">' + cover + '</div>' +
      '<div><div class="land-sr-title">' + esc(r.title) + '</div>' +
      '<div class="land-sr-sub">' + esc(r.author || '') + '</div></div></div>';
  }).join('');
  el.classList.add('open');
}

export function landingDoSearch() {
  const q = document.getElementById('landingSearchInput').value.trim();
  if (q.length < 2) return;
  enterGuest();
  doSearch(q);   // 04.10: pg-search өшті → Кітапхананың іздеуі
}

export function landingOpenBook(slug) {
  enterGuest();
  openBookPage(slug);
}

export function landingOpenBookByTitle(title) {
  document.getElementById('landingSearchResults').classList.remove('open');
  enterGuest();
  api('/api/search?q=' + encodeURIComponent(title)).then(res => {
    const bk = (res.results || []).find(r => r.title === title && r.type === 'kitap');
    if (bk) openBookPage(bk.slug || title);
  });
}

export function landingOpenGenre(slug) {
  enterGuest();
  setCatalogGenre(slug);
  show('catalog');
}

export function botToast(msg) {
  const el = document.getElementById('botToast');
  el.textContent = '🤖 ' + msg;
  el.classList.add('show');
  setTimeout(() => el.classList.remove('show'), 3000);
}

// Бастапқы DOMContentLoaded — auth тексеру + landing/dashboard көрсету.
export async function initApp() {
  initGoals();
  const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
  const icon = isDark ? '☀️' : '🌙';
  const btn = document.querySelector('.btn-theme');
  if (btn) btn.textContent = icon;
  const floatBtn = document.getElementById('themeFloat');
  if (floatBtn) floatBtn.textContent = icon;

  const urlParams = new URLSearchParams(window.location.search);
  const authErr = urlParams.get('error');
  if (authErr) {
    const msgs = {
      bad_auth: 'Авторизация қатесі',
      expired: 'Сессия мерзімі өтті',
      invalid: 'Жарамсыз деректер',
      not_registered: 'Алдымен Telegram-да PARAQTA ботын ашып, /start жіберіңіз',
    };
    setTimeout(() => toast(msgs[authErr] || 'Қате болды'), 500);
    window.history.replaceState({}, '', '/');
  }

  if (COMING_SOON_MODE && !isAdminBypass()) {
    loadLanding();
  } else {
    const res = await api('/api/auth/me');
    if (res.authenticated) {
      loginDone(res);
    } else {
      loadLanding();
      const h = location.hash.replace('#', '');
      if (h === 'catalog' || h.startsWith('book/')) {
        enterGuest();
        if (h.startsWith('book/')) openBookPage(h.replace('book/', ''));
      }
    }
  }

  const lsi = document.getElementById('landingSearchInput');
  if (lsi) {
    let landingSearchTimer = null;
    lsi.addEventListener('input', () => {
      clearTimeout(landingSearchTimer);
      landingSearchTimer = setTimeout(() => landingLiveSearch(lsi.value.trim()), 300);
    });
    lsi.addEventListener('keydown', e => { if (e.key === 'Enter') landingDoSearch(); });
    document.addEventListener('click', e => {
      if (!e.target.closest('.land-search-wrap')) {
        // Нәтиже блогы жоқ бетте (жаңа басты бет) бұрын әр басуда қате шығатын.
        const res = document.getElementById('landingSearchResults');
        if (res) res.classList.remove('open');
      }
    });
  }
}
